import React from "react";
import { Route, Switch } from "react-router-dom";

import Monthly from "./containers/Monthly";
import MonthlyDetails from "./containers/Monthly/Details";

const routes = () => {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/reports/monthly" component={Monthly} />
				<Route exact path="/reports/monthly/:id" component={MonthlyDetails} />
			</Switch>
		</React.Fragment>
	);
};

export default routes;
